import React from 'react';
import cn from 'classnames';
import { Card } from 'reactstrap';
import { Link } from 'react-router-dom';

const HSCodeProductListCard = ({ className, products }) => (
  <Card className={cn(className, 'pa3')}>
    <div>
      <h3 className="f4 mt0">Products that use this HS Code</h3>
      {!products.length && <p>No products use this code.</p>}
      {products.map(p => (
        <h4 className="f5">
          <Link to={`/products/${p.id}`}>{p.name}</Link> (<em>{p.beerStyle.name}</em>)
        </h4>
      ))}
    </div>
  </Card>
);

export default HSCodeProductListCard;



// WEBPACK FOOTER //
// ./src/components/hsCodeProductListCard/hsCodeProductListCard.jsx